import React, { useState } from 'react'
import './styles/LoginRegister.css'
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useModal } from '../contexts/ModalContext';
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { auth } from '../firebase/config';
import { ReactComponent as GoogleLogo } from '../assets/googleLogo.svg'
import { signInWithPopup, GoogleAuthProvider, signInWithEmailAndPassword } from "firebase/auth";
import { createUserIfNotExists } from '../api/UserAPI';
import { Oval } from 'react-loader-spinner';
import logo from '../assets/newro-beige-logo.svg'

export default function Register({ handleClose }) {
    const { openModal } = useModal();

    const [passwordVisibility, setPasswordVisibility] = useState(false);
    const [confirmPasswordVisibility, setconfirmPasswordVisibility] = useState(false);

    const [email, setemail] = useState("")
    const [password, setpassword] = useState("")
    const [confirmPassword, setconfirmPassword] = useState("")
    const [isloading, setisloading] = useState(false);

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSignup()
        }
    }

    function navTo(whereTo) {
        handleClose()
        openModal(whereTo)
    }

    const handleSignup = async (e) => {
        if (password === confirmPassword) {
            setisloading(true);
            try {
                const result = await createUserWithEmailAndPassword(auth, email.trim(), password);
                await sendEmailVerification(result.user);
                const user = result.user;
                createUserIfNotExists(user)
                openModal("alert", {
                    alertProps: { type: 2, message: "Please check your inbox to verfiy your email." },
                });
                handleClose()
            } catch (err) {
                openModal("alert", {
                    alertProps: { type: 0, message: err.code },
                });
            }
        } else {
            openModal("alert", {
                alertProps: { type: 0, message: "Passwords do not match" },
            });
        }
        setisloading(false);
    };

    const handleGoogleAuth = async (e) => {
        const provider = new GoogleAuthProvider();
        signInWithPopup(auth, provider)
            .then((result) => {
                // This gives you a Google Access Token. You can use it to access the Google API.
                const credential = GoogleAuthProvider.credentialFromResult(result);
                const token = credential.accessToken;
                // The signed-in user info.
                const user = result.user;
                createUserIfNotExists(user)
                // IdP data available using getAdditionalUserInfo(result)
                // ...
                openModal("alert", {
                    alertProps: { type: 2, message: "Logged in!" },
                });
                handleClose()
            }).catch((error) => {
                // Handle Errors here.
                const errorCode = error.code;
                const errorMessage = error.message;
                // The email of the user's account used.
                const email = error.customData.email;
                // The AuthCredential type that was used.
                const credential = GoogleAuthProvider.credentialFromError(error);
                openModal("alert", {
                    alertProps: { type: 0, message: errorCode },
                });
                // ...
            });
    };

    return (
        <div className='backdrop' onClick={handleClose}>
            <div className='register-modal-body' onClick={(e) => e.stopPropagation()} >
                <div className='login-top'>
                    <button className='back-button' style={{ backgroundColor: 'transparent' }} onClick={() => navTo('login')}>
                        <ArrowBackIosIcon sx={{ color: 'white', fontSize: '21px' }} />
                    </button>
                    <div class="company-branding">
                        <div class="company-logo">
                            <img src={logo} />
                        </div>
                        <span class="company-name">newro</span>
                    </div>
                    <button className='close-button' style={{ backgroundColor: 'transparent' }} onClick={handleClose}>
                        <CloseIcon sx={{ color: 'white', fontSize: '27px' }} />
                    </button>
                </div>
                {/* The form */}
                <div className="login-inputs">
                    <h3 style={{ color: 'black', margin: 0 }}>Sign up</h3>
                    <div className="login-email">
                        <input
                            onKeyDown={(e) => handleKeyPress(e)}
                            className="email-input"
                            type="text"
                            placeholder="Enter your email"
                            onChange={e => setemail(e.target.value)}
                        />
                    </div>
                    <div className="login-password">
                        <input
                            onKeyDown={(e) => handleKeyPress(e)}
                            className="password-input"
                            type={passwordVisibility ? "text" : "password"}
                            placeholder="Enter your password"
                            onChange={e => setpassword(e.target.value)}
                        />
                        {passwordVisibility ? (
                            <VisibilityIcon
                                className="visibility-icon"
                                onClick={() => setPasswordVisibility(!passwordVisibility)}
                            />
                        ) : (
                            <VisibilityOffIcon
                                className="visibility-icon"
                                onClick={() => setPasswordVisibility(!passwordVisibility)}
                            />
                        )}
                    </div>
                    <div className="login-password">
                        <input
                            onKeyDown={(e) => handleKeyPress(e)}
                            className="password-input"
                            type={confirmPasswordVisibility ? "text" : "password"}
                            placeholder="Confirm your password"
                            onChange={e => setconfirmPassword(e.target.value)}
                        />
                        {confirmPasswordVisibility ? (
                            <VisibilityIcon
                                className="visibility-icon"
                                onClick={() => setconfirmPasswordVisibility(!confirmPasswordVisibility)}
                            />
                        ) : (
                            <VisibilityOffIcon
                                className="visibility-icon"
                                onClick={() => setconfirmPasswordVisibility(!confirmPasswordVisibility)}
                            />
                        )}
                    </div>
                    <button onClick={() => handleSignup()} className="register-btn">
                        {isloading ? (
                            <Oval
                                visible={true}
                                height="30"
                                width="30"
                                color="#ffffff"
                                ariaLabel="oval-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                            />
                        ) : (
                            "Register"
                        )}
                    </button>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <hr style={{ width: '150px', height: '0px', border: '1px solid lightgray' }}></hr>
                    <p style={{ color: 'lightgray' }}>or</p>
                    <hr style={{ width: '150px', height: '0px', border: '1px solid lightgray' }}></hr>
                </div>
                <div className='login-bottom'>
                    <button onClick={() => handleGoogleAuth()} className="google-btn">
                        <GoogleLogo />
                        <h4>Continue with Google</h4>
                        {/* <GoogleLogo /> */}
                    </button>
                    <p className='t-c-text'>By continuing, you agree to <span style={{ fontWeight: 600, color: 'var(--color-primary)' }}>Newro's</span> Terms and Conditions and Privacy Policy</p>
                </div>
            </div>
        </div >)
}
